import React from "react"
import Layout from "../components/layout"
import Section from "../components/section"
import WorkSamples from "../components/workSamples"

const AboutPage = () => {
  return(
    <Layout title="About">
      <Section color={true}>
        <div className="top2">
            <div className="text-col">
              <h2>A little bit about me...</h2>
              <p>
              I’m a product designer with both design and product management experience creating impactful solutions for millions of users across web and mobile platforms. I’ve partnered with teams to lead initiatives to introduce new products to market as well as researching and developing new business opportunities to help guide company direction.
              </p>
              <p>
              My passion is solving problems that impact people's everyday lives through customer focused design. I value <strong>curiosity</strong>, <strong>humility</strong>, and <strong>empathy</strong> in my approach to product development, and I thrive in team environments that foster diverse perspectives, focus actions around the needs of users, and use data to inform decisions.
              </p>
              <p>
              I’m currently working as a Sr. Product Manager at Mailchimp, previously a Staff Designer at Mailchimp. When I’m not working, I’m exploring the outdoors with my wolf pack of 3, discovering new hobbies (like making soap), or teaching myself to code (currently learning React & Swift).
              </p>
              <p>
              If you'd like to chat, you can reach me at <a href="mailto:myra.m.moore@gmail.com?subject=Hello" title="Send me an email">myra.m.moore@gmail.com</a>.
              </p>
            </div>
          </div>
      </Section>
      <Section color={false}>
        <div className="text-col">
          <h2>Some of my history...</h2>
          <h3>Experience</h3>
          <div className="cols">
            <div className="col1">
              <p className="meta">
                <strong>Co-Founder & Product Designer</strong> at <a href="https://gasp-gallery.herokuapp.com/" target="_blank" rel="noreferrer" title="GASP Gallery">GASP Gallery</a> | 1 year
                <br/><em>A generative art platform for creating & buying custom prints.</em>
              </p>
              <p className="meta">
                <strong>Product Management</strong> at <a href="https://www.mailchimp.com" target="_blank" rel="noreferrer"  title="Mailchimp">Mailchimp</a> | 4 years
                <br/><em>A marketing platform for small businesses.</em>
                <br/>· Sr. Product Manager | Current
                <br/>· Product Manager
              </p>
            </div>
            <div className="col2">
              <p className="meta">
                <strong>Product Design</strong> at <a href="https://www.mailchimp.com" target="_blank" rel="noreferrer" title="Mailchimp">Mailchimp</a>  | 3 years
                <br/> <em>A marketing platform for small businesses.</em>
                <br/>· Staff Product Designer
                <br/>· Product Designer
              </p>
              <p className="meta">
                <strong>Digital Designer</strong> at <a href="https://tombras.com/" rel="noreferrer" target="_blank" title="Tombras">Tombras</a>   | 2 years
                <br/><em>A full service advertising agency.</em>
              </p>
            </div>
            <div>
            <br />
              <h3>Education</h3>
              <p className="meta">
                <strong>B.A. in Visual Communications</strong>
                <br/>concentration in Design at Francis Marion University
              </p>
            </div>
          </div>
        </div>

        <Section color={false}>
        <WorkSamples />
        </Section>

      </Section>
    </Layout>

  )
}


export default AboutPage
